const style = {
  disabledInput: {
    '& div[role=button]': {
      WebkitTextFillColor: 'black',
    },
    '& fieldset': {
      border: 'unset',
    },
  },
} as const;

export default style;
